import React, { createRef, useState } from 'react';

import { LinksHeading } from './LinksHeading';
import { LinksList } from './LinksList';
import type { Link } from './types';
import * as styles from './LinksBlockGroup.styles';

export interface LinksBlockGroupProps {
  title: string;
  links: Link[];
  open?: boolean;
}

export const LinksBlockGroup = ({ title, links, open = false }: LinksBlockGroupProps) => {
  const [isOpen, setIsOpen] = useState(open);

  const headingRef = createRef<HTMLElement>();

  const toggleIsOpen = () => (isOpen ? setIsOpen(false) : setIsOpen(true));

  const handleKeyPress = (e: React.KeyboardEvent<HTMLDivElement>): void => {
    const keyCode = e.key;

    if (['Enter', ' ', 'Spacebar'].includes(keyCode)) {
      toggleIsOpen();
    }
  };

  return (
    <details css={styles.item} {...(open && { open })}>
      <summary
        css={styles.heading}
        onClick={toggleIsOpen}
        onKeyDown={handleKeyPress}
        aria-expanded={isOpen}
        ref={headingRef}
      >
        <LinksHeading title={title} open={isOpen} />
      </summary>
      <div style={{ display: 'block' }}>
        <LinksList links={links} />
      </div>
    </details>
  );
};
